import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=cdd4d10a&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"
import style0 from "./Payment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kusanagi/adop-line-ec_tamano/ec/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdd4d10a')) {
      api.createRecord('cdd4d10a', component.options)
    } else {
      api.reload('cdd4d10a', component.options)
    }
    module.hot.accept("./Payment.vue?vue&type=template&id=cdd4d10a&", function () {
      api.rerender('cdd4d10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Payment.vue"
export default component.exports